import { combineReducers } from 'redux';
import { enhanceWithResetActions, loadingStateReducer } from 'redux/utils';
import typeToReducer from 'type-to-reducer';
import {
  CREATE_LICENSE,
  EDIT_LICENSE,
  LOAD_LICENSES,
  LOAD_LICENSES_RESUME,
  RENEW_LICENSE,
  DELETE_LICENSE,
  LOAD_EXPIRED_LICENSES
} from './constants';

const loadLicenseByResume = combineReducers({
  loadingState: loadingStateReducer(LOAD_LICENSES_RESUME),
  dataByResume: typeToReducer(
    {
      [LOAD_LICENSES_RESUME]: {
        SUCCESS: (data, { payload }) => payload
      }
    },
    {}
  )
});

const loadExpiredLicenses = combineReducers({
  loadingState: loadingStateReducer(LOAD_EXPIRED_LICENSES),
  data: typeToReducer(
    {
      [LOAD_EXPIRED_LICENSES]: {
        SUCCESS: (data, { payload }) => payload
      }
    },
    {}
  )
});

export default combineReducers({
  creatingState: loadingStateReducer(CREATE_LICENSE),
  editingState: loadingStateReducer(EDIT_LICENSE),
  loadingState: loadingStateReducer(LOAD_LICENSES),
  deletingState: loadingStateReducer(DELETE_LICENSE),
  updateLoadingState: loadingStateReducer(LOAD_LICENSES),
  data: typeToReducer(
    {
      [CREATE_LICENSE]: {
        SUCCESS: (data, { payload }) => payload
      },
      [EDIT_LICENSE]: {
        SUCCESS: (data, { payload }) => payload
      },
      [LOAD_LICENSES]: {
        SUCCESS: (data, { payload }) => payload
      },
      [RENEW_LICENSE]: {
        SUCCESS: (data, { payload }) => payload
      },
      [DELETE_LICENSE]: {
        SUCCESS: (data, { payload }) => payload
      }
    },
    []
  ),
  licenseResume: enhanceWithResetActions([LOAD_LICENSES_RESUME])(loadLicenseByResume),
  expiredLicenses: enhanceWithResetActions([LOAD_EXPIRED_LICENSES])(loadExpiredLicenses)
});
